class OmetriaPriceRange extends window.BAO.CustomElement() {
  static get requiredExternalElements () {
    return []
  }

  connectedCallback () {
    super.connectedCallback()

    if (this._initialized) return
    this._initialized = true

    this.minInput = this.querySelector('[data-price-range-input="min"]')
    this.maxInput = this.querySelector('[data-price-range-input="max"]')
    this.minDisplay = this.querySelector('[data-price-range-display="min"]')
    this.maxDisplay = this.querySelector('[data-price-range-display="max"]')
    this.trackFill = this.querySelector('[data-price-range-track-fill]')
    this.track = this.querySelector('[data-price-range-track]')

    if (
      !this.minInput ||
      !this.maxInput ||
      !this.minDisplay ||
      !this.maxDisplay ||
      !this.trackFill ||
      !this.track
    ) {
      return
    }

    this.currency = this.getAttribute('data-currency') || '£'
    this.min = parseFloat(this.getAttribute('data-min')) || 0
    this.max = parseFloat(this.getAttribute('data-max')) || 0

    if (this.max === 0) return

    this.readFromUrl()
    this.setupListeners()
    this.updatePriceRange()

    let resizeTimeout
    this.listeners.add(window, 'resize', () => {
      clearTimeout(resizeTimeout)
      resizeTimeout = setTimeout(() => {
        this.updatePriceRange()
      }, 100)
    })
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.minInput, 'input', () => this.updatePriceRange())
    this.listeners.add(this.maxInput, 'input', () => this.updatePriceRange())
  }

  readFromUrl () {
    const urlParams = new URLSearchParams(window.location.search)
    const priceParam = urlParams.get('price')
    if (priceParam) {
      const parts = priceParam.split('~')
      if (parts.length >= 1) {
        const minFromUrl =
          parts[0] && parts[0].trim() !== '' ? parseFloat(parts[0]) : null
        const maxFromUrl =
          parts[1] && parts[1].trim() !== '' ? parseFloat(parts[1]) : null

        if (minFromUrl !== null && !isNaN(minFromUrl) && minFromUrl >= 0) {
          this.minInput.value = minFromUrl
        }
        if (maxFromUrl !== null && !isNaN(maxFromUrl) && maxFromUrl >= 0) {
          this.maxInput.value = maxFromUrl
        }
      }
    }
  }

  updatePriceRange () {
    try {
      const minValue = parseFloat(this.minInput.value) || 0
      const maxValue = parseFloat(this.maxInput.value) || 0

      if (minValue > maxValue) {
        this.minInput.value = maxValue
        this.maxInput.value = minValue
        return this.updatePriceRange()
      }

      this.minDisplay.textContent = `${this.currency}${Math.round(minValue)}`
      this.maxDisplay.textContent = `${this.currency}${Math.round(maxValue)}`

      const range = this.max - this.min
      if (range > 0) {
        const minPercent = ((minValue - this.min) / range) * 100
        const maxPercent = ((maxValue - this.min) / range) * 100

        this.trackFill.style.left = `${minPercent}%`
        this.trackFill.style.width = `${maxPercent - minPercent}%`
      } else {
        this.trackFill.style.left = '0%'
        this.trackFill.style.width = '0%'
      }
    } catch (error) {}
  }
}

if (!customElements.get('ometria-price-range')) {
  customElements.define('ometria-price-range', OmetriaPriceRange)
}

;(function () {
  'use strict'

  if (window.omPriceRangeBound) return
  window.omPriceRangeBound = true

  function initPriceRange () {
    try {
      const containers = document.querySelectorAll(
        '[data-price-range-container]',
      )
      containers.forEach(container => {
        if (container._priceRangeInitialized) {
          return
        }

        const minInput = container.querySelector(
          '[data-price-range-input="min"]',
        )
        const maxInput = container.querySelector(
          '[data-price-range-input="max"]',
        )

        if (!minInput || !maxInput) {
          return
        }

        container._priceRangeInitialized = true

        if (customElements && customElements.get('ometria-price-range')) {
          const component = container.querySelector('ometria-price-range')
          if (component && component.updatePriceRange) {
            setTimeout(() => {
              if (component.updatePriceRange) {
                component.updatePriceRange()
              }
            }, 100)
            return
          }
        }

        initPriceRangeManual(container, minInput, maxInput)
      })
    } catch (error) {}
  }

  function initPriceRangeManual (container, minInput, maxInput) {
    const minDisplay = container.querySelector(
      '[data-price-range-display="min"]',
    )
    const maxDisplay = container.querySelector(
      '[data-price-range-display="max"]',
    )
    const trackFill = container.querySelector('[data-price-range-track-fill]')
    const track = container.querySelector('[data-price-range-track]')
    const currency = container.getAttribute('data-currency') || '£'
    const min = parseFloat(container.getAttribute('data-min')) || 0
    const max = parseFloat(container.getAttribute('data-max')) || 0

    if (!minDisplay || !maxDisplay || !trackFill || !track || max === 0) {
      return
    }

    const urlParams = new URLSearchParams(window.location.search)
    const priceParam = urlParams.get('price')
    if (priceParam) {
      const parts = priceParam.split('~')
      if (parts.length >= 1) {
        const minFromUrl =
          parts[0] && parts[0].trim() !== '' ? parseFloat(parts[0]) : null
        const maxFromUrl =
          parts[1] && parts[1].trim() !== '' ? parseFloat(parts[1]) : null

        if (minFromUrl !== null && !isNaN(minFromUrl) && minFromUrl >= 0) {
          minInput.value = minFromUrl
        }
        if (maxFromUrl !== null && !isNaN(maxFromUrl) && maxFromUrl >= 0) {
          maxInput.value = maxFromUrl
        }
      }
    }

    function updatePriceRange () {
      try {
        const minValue = parseFloat(minInput.value) || 0
        const maxValue = parseFloat(maxInput.value) || 0

        if (minValue > maxValue) {
          minInput.value = maxValue
          maxInput.value = minValue
          return updatePriceRange()
        }

        minDisplay.textContent = `${currency}${Math.round(minValue)}`
        maxDisplay.textContent = `${currency}${Math.round(maxValue)}`

        const range = max - min
        if (range > 0) {
          const minPercent = ((minValue - min) / range) * 100
          const maxPercent = ((maxValue - min) / range) * 100

          trackFill.style.left = `${minPercent}%`
          trackFill.style.width = `${maxPercent - minPercent}%`
        } else {
          trackFill.style.left = '0%'
          trackFill.style.width = '0%'
        }
      } catch (error) {}
    }

    minInput.addEventListener('input', updatePriceRange)
    maxInput.addEventListener('input', updatePriceRange)
    minInput.addEventListener('change', updatePriceRange)
    maxInput.addEventListener('change', updatePriceRange)

    let resizeTimeout
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout)
      resizeTimeout = setTimeout(() => {
        updatePriceRange()
      }, 100)
    })

    setTimeout(() => {
      updatePriceRange()
    }, 100)
    updatePriceRange()
  }

  function runPriceRangeInit () {
    initPriceRange()
    setTimeout(initPriceRange, 100)
    setTimeout(initPriceRange, 500)
    setTimeout(initPriceRange, 1000)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runPriceRangeInit)
  } else {
    runPriceRangeInit()
  }

  if (window.MutationObserver && document.body) {
    try {
      const observer = new MutationObserver(mutations => {
        let shouldInit = false
        mutations.forEach(mutation => {
          if (mutation.addedNodes && mutation.addedNodes.length) {
            for (let index = 0; index < mutation.addedNodes.length; index++) {
              const node = mutation.addedNodes[index]
              if (node.nodeType === 1) {
                if (
                  (node.matches &&
                    node.matches('[data-price-range-container]')) ||
                  (node.querySelector &&
                    node.querySelector('[data-price-range-container]'))
                ) {
                  shouldInit = true
                }
              }
            }
          }
        })
        if (shouldInit) {
          setTimeout(initPriceRange, 100)
        }
      })
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      })
    } catch (error) {}
  }

  document.addEventListener(
    'click',
    event => {
      const trigger = event.target.closest(
        '[data-drawers-trigger="collection-filters"]',
      )
      if (trigger) {
        setTimeout(initPriceRange, 300)
      }
    },
    true,
  )
})()
